"use client";
import React, { useEffect, useRef, type JSX } from "react";
import { Drawer } from "@cappelendamm/design-system/react";
import { PiListLight, PiX } from "react-icons/pi";
import { usePathname } from "next/navigation";

type HeaderDrawerProps = {};

export default function HeaderDrawer({
  children,
  ...rest
}: HeaderDrawerProps & Omit<JSX.IntrinsicElements["button"], "onClick">) {
  const ref = useRef<HTMLDialogElement>(null);
  const pathname = usePathname();
  useEffect(() => {
    if (ref.current) ref.current.close();
    document.body.style.overflow = "";
  }, [pathname]);
  return (
    <>
      <button
        onClick={() => {
          if (ref.current) ref.current.showModal();
          document.body.style.overflow = "hidden";
        }}
        {...rest}
      >
        <PiListLight size={28} />
      </button>
      <Drawer
        variant="left"
        ref={ref}
        className="fixed overflow-y-auto pt-20 pb-0"
      >
        <button
          className="absolute top-4 right-4 flex h-12 w-12 items-center justify-center rounded-full bg-surface-150"
          onClick={() => {
            if (ref.current) ref.current.close();
            document.body.style.overflow = "";
          }}
          aria-label="Lukk"
        >
          <PiX size={24} />
        </button>
        {children}
      </Drawer>
    </>
  );
}
